import FallbackInterface from './FallbackInterface';
import * as T from './types';

export { createNoopFallbackInterface } from './NoopInterface';

let fallbackInterface: FallbackInterface;

export function getFallbackInterface(): FallbackInterface {
  return fallbackInterface;
}

export default function initializeFallbackInterface(): T.FallbackInterfaceType {
  if (fallbackInterface) return fallbackInterface.getInterface();

  fallbackInterface = new FallbackInterface();

  return fallbackInterface.getInterface();
}
